export default "__VITE_ASSET__wGC9D2AF__";